var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCheckoutAsClient)?_c('div',{staticClass:"header-user-type"},[_c('UserType',{attrs:{"reload-page":""}}),(_vm.isManager)?_c('UserSelectedShop'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }